import BigNumber from 'bignumber.js';

export const MaxUint256 = new BigNumber('0xffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff')
export const MaxUint128 = new BigNumber('0xffffffffffffffffffffffffffffffff')
